import {
  COLOR_PALETTE_DATA,
  ILLUSTRATIONS_IMAGES_DATA,
  OTHER_DESIGN_DATA,
  UI_COMPONENTS_DATA,
  UI_TYPOGRAPHY_DATA,
} from "const/case-study/road-assistance-mobile-app-case-study";
import Image from "next/image";
import { useEffect, useState } from "react";
import MarqueeHeading from "./common/MarqueeHeading";
import SpaceWrapper from "./common/SpaceWrapper";
import Thankyou from "./Thankyou";

const DesignSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, []);
  return (
    <SpaceWrapper className="!pt-16 !px-0 !pb-0 overflow-hidden">
      <div>
        <div className="hidden md:block">
          <MarqueeHeading marqueeTitle={"DESIGN"} smallTitle={"Design"} />
        </div>
        {/* for mobile */}
        {isMobile && (
          <div>
            <h2 className="text-white mt-12 mb-8 pl-6 font-bold text-5xl">
              <span className="font-gilroy">Design</span>
            </h2>
          </div>
        )}
        <div className="mt-24 md:mt-0">
          <h3 className="flex items-center font-bold md:font-semibold text-3xl md:text-4xl text-white mb-6 ml-6 md:mb-16 md:pt-28 md:pl-8 xl:pl-0 xl:ml-48">
            <div className="mr-4">
              <Image
                alt="star"
                loading="lazy"
                src="/assets/case-study/roaddy/blue-star.webp"
                width={35}
                height={35}
              />
            </div>
            <span className="font-gilroy md:font-outfit">
              Logo Design Concept
            </span>
          </h3>
        </div>
        <div className="px-6 md:p-8 xl:py-0 xl:px-48">
          <div>
            {isMobile ? (
              <Image
                alt="Showing logo design concept, as visualized with combination of two entities."
                loading="lazy"
                src={"/assets/case-study/roaddy/loc-m-icon.webp"}
                width={390}
                height={411}
              />
            ) : (
              <Image
                alt="Showing logo design concept, as visualized with combination of two entities."
                loading="lazy"
                src={"/assets/case-study/roaddy/logo-design-concept.webp"}
                width={1920}
                height={951}
              />
            )}
          </div>
          <p className="font-normal text-justify xl:text-start text-lg md:text-2xl xl:text-lg text-white font-gilroy pb-16 md:py-6 md:px-4 xl:py-32 xl:px-48">
            <span className="font-gilroy">
              When we say Roadside Assistance, we expect to see a helper in
              front of us to take us out of the problematic situation. Hence we
              decided to put a &#34;Mechanic friend&#34; symbol in our logo
              along with &#34;Location&#34; to indicate that He will come to you
              no matter where you are stuck.
            </span>
          </p>
          <div>
            {isMobile ? (
              <Image
                alt="How the Roaddy name came into existence, which is a combination of Road + Buddy."
                src={"/assets/case-study/roaddy/rod-m-icon.webp"}
                width={390}
                height={267}
              />
            ) : (
              <Image
                alt="How the Roaddy name came into existence, which is a combination of Road + Buddy."
                src={"/assets/case-study/roaddy/roaddy-logo.webp"}
                width={1920}
                height={581}
              />
            )}
          </div>
          <p className="font-normal text-justify xl:text-start text-lg md:text-2xl xl:text-lg text-white font-gilroy py-16 md:py-6 md:px-4 xl:py-32 xl:px-48">
            <span className="font-gilroy">
              The best way to calm someone is to give them support, and who can
              do it better than your own &#34;Buddy&#34;? Hence we named it
              &#34;Roaddy&#34; which comes from Road + Buddy & states that Your
              buddy will always come to you when you get stuck in the middle of
              the Road.
            </span>
          </p>
          <div className="pb-20 md:py-12 md:px-4 xl:px-48 xl:pt-0 xl:pb-12 md:text-center xl:text-start">
            <p>
              <span className="font-normal text-[#3a3a3a] font-righteous text-5xl md:text-7xl">
                Road
              </span>
              <span className="font-normal text-[#3a3a3a] font-righteous text-5xl md:text-7xl mx-7 xl:mx-12">
                +
              </span>
              <span className="font-normal text-[#3a3a3a] font-righteous text-5xl md:text-7xl">
                Buddy
              </span>
              <span className="hidden xl:inline font-normal text-[#3a3a3a] font-righteous text-7xl mx-12">
                =
              </span>
              <span className="font-normal text-celtic-blue font-righteous flex justify-center xl:inline mt-8 text-5xl md:text-7xl">
                Roaddy
              </span>
            </p>
          </div>
          <div className="md:py-2 xl:py-12 xl:px-48">
            <h3 className="text-white font-bold text-3xl md:text-4xl flex items-center">
              <div className="mr-4">
                <Image
                  alt="star"
                  loading="lazy"
                  src="/assets/case-study/roaddy/blue-star.webp"
                  width={35}
                  height={35}
                />
              </div>
              <span className="font-gilroy md:font-outfit">UI Kit</span>
            </h3>
            <div className="flex flex-col md:flex-row text-white py-12 md:py-24">
              <div className="w-full md:w-1/2">
                <p className="font-bold text-lg md:font-semibold md:text-4xl text-white">
                  <span className="font-gilroy md:font-outfit">Typography</span>
                </p>
                <p className="text-8xl leading-snug font-bold md:font-semibold md:text-9xl text-white md:pt-8 md:leading-snug">
                  <span className="font-gilroy md:font-outfit inline-block">
                    Gilroy
                  </span>
                </p>
              </div>
              <div className="w-full md:w-1/2">
                {UI_TYPOGRAPHY_DATA.map((value) => (
                  <div
                    key={value.head}
                    className="flex items-center border border-dashed border-[#3a3a3a] rounded mb-6 last:mb-0 h-12"
                  >
                    <div
                      className="font-bold text-white w-1/2 ml-4"
                      style={{ fontSize: value.fontsize }}
                    >
                      <span className="font-gilroy">{value.head}</span>
                    </div>
                    <div
                      className="font-normal text-white w-1/2 text-end mr-4"
                      style={{ fontSize: value.fontsize }}
                    >
                      <span className="font-gilroy">{value.size}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="py-24">
              <h4 className="text-lg md:text-4xl font-bold md:font-semibold text-white mb-16">
                <span className="font-gilroy md:font-outfit">
                  Color Palette
                </span>
              </h4>
              <div className="grid md:grid-cols-2 xl:grid-cols-5 gap-x-3">
                {COLOR_PALETTE_DATA.map((values, index) => (
                  <div
                    key={values}
                    className={`${index === 0 ? "col-span-2 xl:col-auto" : ""}`}
                  >
                    <div
                      className={`h-12 rounded md:py-6 xl:py-0 ${
                        index === 0 ? "w-1/2 md:w-48 xl:w-auto" : ""
                      }`}
                      style={{ background: values }}
                    ></div>
                    <p className="font-normal md:font-medium text-lg md:text-xl text-white mt-4 mb-12 md:mb-8 md:mt-0 xl:mt-6 xl:mb-0">
                      <span>{values}</span>
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="py-24">
              <h4 className="text-lg md:text-4xl font-bold md:font-semibold text-white mb-16">
                <span className="font-gilroy md:font-outfit">Icons</span>
              </h4>
              <div className="w-full">
                <div className="hidden md:block">
                  <Image
                    alt="Icons that are used in the making of service app"
                    className="w-full"
                    loading="lazy"
                    src="/assets/case-study/roaddy/icons-desk.webp"
                    width={1229}
                    height={143}
                  />
                </div>
                <div className="block md:hidden">
                  <Image
                    alt="Icons that are used in the making of service app"
                    className="w-full"
                    loading="lazy"
                    src="/assets/case-study/roaddy/mob-icons-group.webp"
                    width={338}
                    height={438}
                  />
                </div>
              </div>
            </div>
            <div className="py-24">
              <h4 className="text-lg md:text-4xl font-bold md:font-semibold text-white mb-16">
                <span className="font-gilroy md:font-outfit">
                  Illustrations
                </span>
              </h4>
              <div className="grid grid-cols-2 xl:grid-cols-5 gap-x-3 md:gap-y-3 md:gap-x-0">
                {ILLUSTRATIONS_IMAGES_DATA.map((value, index) => (
                  <div
                    key={value}
                    className={`${
                      index === ILLUSTRATIONS_IMAGES_DATA.length - 1
                        ? "hidden xl:block"
                        : ""
                    }`}
                  >
                    <div
                      className={
                        ILLUSTRATIONS_IMAGES_DATA.length - 1 === index
                          ? ""
                          : "mb-6 md:mb-16 xl:pr-6 xl:mb-0 uiComponentWrapper"
                      }
                    >
                      <Image
                        alt="Illustrations used in the app making"
                        loading="lazy"
                        src={value}
                        width={200}
                        height={161}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="py-24">
              <h4 className="text-lg md:text-4xl font-bold md:font-semibold text-white mb-16">
                <span className="font-gilroy md:font-outfit">
                  UI Components
                </span>
              </h4>
              <div className="block md:grid grid-cols-2 md:grid-cols-3 gap-x-3 md:gap-y-3 md:gap-x-0">
                {UI_COMPONENTS_DATA.map((value, index) => (
                  <div key={value.id}>
                    <div
                      className={
                        UI_COMPONENTS_DATA.length - 1 === index
                          ? ""
                          : "mb-6 md:mb-16 xl:mr-4 xl:mb-0 uiComponentWrapper fs-0"
                      }
                    >
                      <Image
                        alt={value.alt}
                        loading="lazy"
                        src={value.src}
                        width={340}
                        height={356}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div>
          <h3 className="flex items-center font-bold md:font-semibold text-3xl md:text-4xl text-white mb-6 ml-6 md:mb-16 md:pt-28 md:pl-8 xl:pl-0 xl:ml-48">
            <div className="mr-4">
              <Image
                alt="star"
                loading="lazy"
                src="/assets/case-study/roaddy/blue-star.webp"
                width={35}
                height={35}
              />
            </div>
            <span>Visual Design</span>
          </h3>
          <p className="hidden md:block font-normal text-2xl text-white xl:px-48 md:px-8 md:text-justify xl:text-start">
            <span className="font-gilroy">
              We have converted the wireframes into final screens and tried to
              keep the UI simple and intuitive with a user-centered approach.
              The below design has simple sign-in & verification screens and a
              booking process.
            </span>
          </p>
          <div className="w-full">
            <div className="hidden md:block">
              <Image
                alt="Screenshots showing many screens of app on different stages"
                loading="lazy"
                src="/assets/case-study/roaddy/visual-design.webp"
                width={1920}
                height={6371}
              />
            </div>
            <div className="md:hidden flex justify-center w-full pl-6 pr-6 pt-12">
              <Image
                alt="Screenshots showing many screens of app on different stages"
                loading="lazy"
                src="/assets/case-study/roaddy/vd-mob.webp"
                width={339}
                height={3039}
                layout="fixed"
              />
            </div>
          </div>
        </div>
        <div className="hidden md:block pt-24">
          <h3 className="text-white md:px-8 xl:pl-48 font-bold text-4xl mb-24 flex items-center">
            <div className="mr-4">
              <Image
                alt="star"
                loading="lazy"
                src="/assets/case-study/roaddy/blue-star.webp"
                width={35}
                height={35}
              />
            </div>
            <span>Other Screens</span>
          </h3>
          <div className="flex flex-wrap md:pl-4 xl:pl-16">
            {OTHER_DESIGN_DATA.map((values, index) => (
              <div
                key={values.id}
                className="flex justify-center w-full md:w-4/12"
              >
                <div
                  className={`md:pr-4 xl:pr-16 ${
                    index === 1 || index === 4 || index === 7 ? "pt-24" : ""
                  }`}
                >
                  <Image
                    alt={values.alt}
                    src={values.src}
                    width={431}
                    height={872}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <Thankyou />
      </div>
    </SpaceWrapper>
  );
};
export default DesignSection;
